const WageDevelopments = (target) => {
  // * WageDevelopmentsCalculator.cshtml
  // * WageDevelopmentsController.cs

  const method = {
    init: () => {
      if (target) {
        const form = target;

        form.addEventListener("submit", (e) => {
          e.preventDefault();
          console.log("submitting wage developments");
          method.submit(form);
        });
      }
    },

    submit: async (form) => {
      const button = form.querySelector("button[type=submit]");
      const callout = form.querySelector(".callout");
      const data = new FormData(form);
      const action = form.getAttribute("action");
      const formMethod = form.getAttribute("method");

      if (callout) {
        callout.remove();
      }

      button.disabled = true;
      button.classList.add("button--loading");

      fetch(action, {
        method: formMethod,
        body: data,
      })
        .then(res => res.json())
        .then((response) => {
          if (response.success) {
            method.renderMessage(form, response.result);
            button.classList.remove("button--loading");
            button.disabled = false;
          } else {
            method.renderError(form, response.message, "error");
            button.classList.remove("button--loading");
            button.disabled = false;
          }
        })
        .catch((ex) => {
          console.log(ex);
          method.renderError(form, "Server error", "error");
        });
    },

    renderMessage: (form, response) => {
      const resultEl = form.querySelector(".js-developments-result");

      const fields = {
        amount: [
          "LaunFra",
          "LaunTil",
          "NyLaunVisitala",
          "NyLaunVR",
          "NyLaunNeyslu",
          "NyLaunSA",
          "SeinniLaun",
        ],
        number: [
          "FyrriNeyslu",
          "SeinniNeyslu",
          "FyrriVR",
          "SeinniVR",
          "FyrriVisitala",
          "SeinniVisitala",
        ],
        percentage: [
          "Breyting",
          "BreytingNeyslu",
          "BreytingVR",
          "BreytingVisitala",
          "BreytingSA",
        ],
      };

      const pascalToCamelCase = (str) => {
        if (!str) return str;
        return str.charAt(0).toLowerCase() + str.slice(1);
    }

      fields.amount.forEach((field) => {
        resultEl.querySelector(`[data-value=${field}]`).innerHTML = `${response[pascalToCamelCase(field)].toLocaleString().replace(/,/g, ".")} kr.`;
      });

      fields.number.forEach((field) => {
        resultEl.querySelector(`[data-value=${field}]`).innerHTML = response[pascalToCamelCase(field)].toString().replace(".", ",");
      });

      fields.percentage.forEach((field) => {
        resultEl.querySelector(`[data-value=${field}]`).innerHTML = `${(response[pascalToCamelCase(field)] * 100).toFixed(2).toLocaleString().replace(".", ",")}%`;
      });

      resultEl.querySelector("[data-value=year1]").innerHTML = form.querySelector("[name=yearOne").options[form.querySelector("[name=yearOne").selectedIndex].text;
      resultEl.querySelector("[data-value=year2]").innerHTML = form.querySelector("[name=yearTwo").options[form.querySelector("[name=yearTwo").selectedIndex].text;

      resultEl.querySelector("[data-value=calc]").innerHTML = `${((response.launTil / response.seinniNeyslu / (response.launFra / response.fyrriNeyslu) - 1) * 100).toFixed(2).toLocaleString().replace(".", ",")}%`;

      resultEl.querySelector("[data-value=yearMonth]").innerHTML = form.querySelector("[name=yearTwo").options[form.querySelector("[name=yearTwo").selectedIndex].text;

      resultEl.style.display = "block";
    },

    renderError: (el, message, type) => {
      el.insertAdjacentHTML(
        "beforeend",
        `<div class="callout callout--${type}">${message}</div>`
      );
    },
  };

  method.init();
};

export default WageDevelopments;
